import * as React from "react";
const HaircutMale4 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<title>{"coiffure m 4"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffures_m" data-name="coiffures m">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M644,129c-4-13-9-18-9-18s-11-54-72-47c-61-7-72,47-72,47s-5,5-9,18,6,67,6,67c9,1,8,19,11,19,0-4-2-33,7-42,6.08-6.08,3-14,3-14s8,5,25,8c-12-23,2-29,8-31s21,16,21,16,15-18,21-16,20,8,8,31c17-3,24-9,24-9s-2.08,8.92,4,15c9,9,7,38,7,42,3,0,2-18,11-19C638,196,648,142,644,129Z"
			/>
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M563,235s-31,0-33,19c9,0,21,1,25-1a37.32,37.32,0,0,0,8-6,37.32,37.32,0,0,0,8,6c4,2,16,1,25,1C594,235,563,235,563,235Z"
			/>
		</g>
	</svg>
);
export default HaircutMale4;
